import React from 'react';
import FormSettings from './forms/FormSettings.react';

class ConfiguratorSettings extends React.Component {

    static get defaultProps() {
        return {
            ConfiguratorManager: {}
        }
    }

    render() {

        let { ConfiguratorManager } = this.props;

        return (
            <aside>
                <div className="tab-content">
                    <div className="tab-pane active">
                        <FormSettings ConfiguratorManager={ConfiguratorManager} />
                    </div>
                </div>
            </aside>
        );
    }

}

export default ConfiguratorSettings;


// WEBPACK FOOTER //
// ./src/js/components/ConfiguratorSettings.react.jsx